var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container-height"},[_c('div',{staticStyle:{"width":"50vw","height":"100%"},attrs:{"id":"taskDetailsMap"},on:{"dblclick":_vm.zoomIn,"contextmenu":_vm.zoomOut}})])}
var staticRenderFns = []

export { render, staticRenderFns }